<template>
  <div class="menu-wrap" :class="isOpenMenu ? 'isOpen' : ''" >
    <div class="menu-toggle" @click="toggleOpen" >
      <div class="bar" ></div>
    </div>
    <div class="menu-body">
      <div class="menu-link-grid">
        <div class="menu-link-top">
          <ul>
            <li 
              class="selected menu-item home-menu" 
              
            >
              <router-link 
              @click.native="toggleOpen"
              :to="'/' + switchLanguage + '/'"
              exact
              >
                <b>{{ $t("message.nav_home") }}</b>
              </router-link>
            </li>
            <li class="sub-nav-parent menu-item prod-menu" @click="openSubNav" >
              <p><b>{{ $t("message.nav_product") }}</b></p>
              <div class="sub-nav">
                <router-link 
                @click.native="toggleOpen"
                :to="'/' + switchLanguage + '/granulate'" exact>
                  <span class="menu-item sub-item">{{ $t("message.nav_product_beads") }}</span>
                </router-link>
                <router-link 
                @click.native="toggleOpen"
                :to="'/' + switchLanguage + '/flakes'" exact>
                  <span class="menu-item sub-item">{{ $t("message.nav_product_flakes") }}</span>
                </router-link>
              </div>
            </li>
            <li @click="scrollToFooter()">
              <b>{{ $t("message.nav_contact") }}</b>
            </li>
          </ul>
        </div>
        <div class="menu-link-bottom">
          <div class="menu-lang-switcher" :class="isOpen ? 'open' : ''">
            <span>Language: </span>
            <div class="current-lang" @click="toggleSwitch()" >
              <span class="current-lang-indicator">IT</span>
            </div>
            <div class="drop-lang">
              <div @click="changeLanguage('it')">
                <router-link :to="'/it' + '/' + this.$route.path.split('/')[2]">
                  <p class="option">
                    <span class="language">IT</span>
                  </p>
                </router-link>
              </div>
              <div @click="changeLanguage('en')">
                <router-link :to="'/en' + '/' + this.$route.path.split('/')[2]">
                  <p class="option">
                    <span class="language">EN</span>
                  </p>
                </router-link>
              </div>
            </div>
          </div>
          <a class="external" href="http://www.mairetecnimont.com" target="_blank">mairetecnimont.com</a>
          <a class="external" href="http://www.nextchem.com" target="_blank">nextchem.com</a>

        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'MenuMobile',
  props: ['changeLanguage', 'switchLanguage', 'isOpenMenu', 'isOpen', 'toggleOpen', 'toggleSwitch', 'contact'],
  data(){
    return{
    }
  },
  methods: {
    scrollToFooter(){
      let footer = document.querySelector('footer');

      this.$emit('update:isOpenMenu', false)
      document.body.classList.toggle('lock')
      setTimeout(()=>{
        footer.scrollIntoView({behavior: "smooth", block: "end", inline: "nearest"});
      }, 300)
    },
    openSubNav(){
      event.currentTarget.classList.toggle('open');
    },
    setSelection(name){
      
      let homeMenu = document.querySelectorAll('.home-menu');
      let prodMenu = document.querySelectorAll('.prod-menu');

      let selected = (name === 'home' || name === 'root') ? homeMenu : prodMenu;
      let unselected = (name === 'home' || name === 'root') ? prodMenu : homeMenu;
      for(var i = 0; i < selected.length;i++){
        selected[i].classList.add('selected')
        unselected[i].classList.remove('selected')
      }
    }
  },
  mounted(){    
    this.setSelection(this.$route.name)
  },
  watch: {
    '$route.name': function(name){
        this.setSelection(name)
    }
  }
}
</script>
<style lang="scss" scoped>
  .menu-wrap{
    display: none;
    @media screen and(max-width: 900px){
      display: block;
    }
    .menu-toggle{
      position: relative;
      height: 30px;
      width: 30px;
      align-content: center;
      justify-content: center;
      flex-direction: column;
      transform: rotate(0deg);
      // transition: transform .25s ease-out 0s;
      display: none;
      @media screen and(max-width: 900px) {
        display: flex;
      }
      .bar{
        width: 1.4rem;
        transform: translateY(-50%);
        transition: all .1s ease;
        height: 2px;
        background: #33586E;
        top: 50%;
        &::after,
        &::before{
          content: '';
          position: absolute;
          left: 0;
          height: 2px;
          background: #33586E;
          width: calc(1.4rem + 6px);
        }
        &::before {
          bottom: 0.5rem;
          transition: all .3s ease;
        }
        &::after {
          top: 0.5rem;
          transition: all .3s ease;
        }
      }
      
    }
    .menu-body{
      position: fixed;
      z-index: 3;
      background-color: #396077;
      bottom: 0;
      top: 75px;
      left: 0;
      right: 0;
      transform: translateX(100%);
      transition: transform .5s ease-in-out;
      overflow: hidden;
      display: none;
      @media screen and(max-width: 900px){
        display: block;
      }
      .menu-bg{
        position: absolute;
        bottom: 0;
        right: -35%;
        width: 160%;
      }
    }
    &.isOpen{
      .bar{
        background: transparent;
        &::after {
          transform: rotate(-45deg);
          top: 0;
          transition: all .3s ease;
        }
        &::before {
          transform: rotate(45deg);
          bottom: 0;
          transition: all .3s ease;
        }
      }
      .menu-body{
        transform: translateX(0%);
      }
    }
    .menu-link-grid{
      position: absolute;
      top: 0;
      width: 100%;
      height: 100%;
      z-index: 5;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      color: #fff;
      padding: 0 10px;
    }
    .menu-link-top{
      padding-top: 50px;
      font-size: 30px;
      line-height: 37px;
      ul{
        margin: 0;
        padding: 0;
        li{
          padding-left: 10px;
          &.home-menu{
            margin-bottom: 30px;
            padding-left: 10px;
            &.selected{
              border-left: 2px solid #68A926;
            }
          }
          &.sub-nav-parent{
            margin-bottom: 30px;
            padding: 0;
            &.selected{
              p{
                border-left: 2px solid #68A926;
                
              }
            }
            p,.sub-nav{
              padding-left: 10px;
              color: #fff;
            }
            .sub-nav{
              position: relative;
              overflow: hidden;
              display: flex;
              flex-direction: column;
              font-size: 14px;
              height: 0;
              transition: height .5s ease-out;
              a{
                padding: 5px 0 0;
              }
              @media screen and(max-width: 900px){
                font-size: 16px;
                a{
                  padding: 8px 0 0;
                }
              }
              
            }
            &.open{
              .sub-nav{
                height: 90px;
              }
            }
          }
          
        }
      }
    }
    .menu-lang-switcher{
      position: relative;
      margin-bottom: 10px;
      .current-lang{
        position: relative;
        display: inline-block;
        line-height: 35px;
        text-transform: uppercase;
        width: 50px;
        text-align: left;
        cursor: pointer;
        font-weight: 700;
        &::after{
          content: '';
          position: absolute;
          width: 0;
          height: 0;
          border-style: solid;
          border-width: 6px 4px 0 4px;
          border-color: #fff transparent transparent transparent;
          right: 10px;
          top: 50%;
          margin-top: -3px;
          transform: rotate(0deg);
          transform-origin: 50% 50%;
          transition: transform .5s ease-out;
        }
      }
      .drop-lang{
        position: absolute;
        top: -55px;
        width: 50px;
        left: 50px;
        text-align: left;
        opacity: 0;
        transition: opacity .5s ease-out;
        color: #fff;
        a {
          line-height: 25px;
          color: #fff;
        }
      }
      &.open{
        .drop-lang{
          opacity: 1;
          p{
            color: #fff;
          }
        }
        .current-lang{
          &::after{
            transform: rotate(-180deg);
          }
        }
      }
    }
    .menu-link-bottom{
      position: relative;
      display: flex;
      flex-direction: column;
      width: 100%;
      padding-left: 10px;
      padding-bottom: 40px;
    }
  }
  .external{
    padding-bottom: 10px;
  }
</style>


// WEBPACK FOOTER //
// Menu.vue?7065b90c